import type { ReactNode } from "react";

export function Label({ children }: { children: ReactNode }) {
  return (
    <span
      className="inline-block text-[10px] font-bold tracking-[0.2em] uppercase border px-2 py-1"
      style={{
        color: "#FF5500",
        borderColor: "rgba(255,85,0,0.35)",
      }}
    >
      {children}
    </span>
  );
}

export function OrangeLine() {
  return <div className="w-10 h-[3px] bg-[#FF5500] my-4" />;
}
